import { withBemMod } from '@bem-react/core';
import { cnMessageBar } from '../MessageBar';
import './MessageBar_type_error.css';
/**
 * Модификатор, отвечающий за тип компонента.
 * @param {IMessageBarTypeErrorProps} props
 */
export var withTypeError = withBemMod(cnMessageBar(), { type: 'error' });
